import angular from 'angular'

// components
import headMenu from './component/headMenu.js'

export default angular
  .module('portalApp.headMenu', [])
  .component('headMenu', headMenu)
  .name
